import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';

const MAIL_QUEUE_TRACKING_KEY_QUERY_PARAM = 'mtk';

const MAIL_QUEUE_TRACKING_MUTATION = gql(`
  mutation trackMailQueue($trackingKey: String!) {
    mailQueueTracking(trackingKey: $trackingKey)
  }
`);

const useMailQueueTracking = () => {
  const { search } = useLocation();
  const [trackMailQueue] = useMutation(MAIL_QUEUE_TRACKING_MUTATION);
  
  const trackedKeys = useRef(new Set());

  useEffect(() => {
    const params = new URLSearchParams(search);
    const trackingKey = params.get(MAIL_QUEUE_TRACKING_KEY_QUERY_PARAM);

    if (trackingKey && !trackedKeys.current.has(trackingKey)) {
      trackMailQueue({ variables: { trackingKey } });
      
      trackedKeys.current.add(trackingKey);
    }
  }, [search, trackMailQueue]);
};

export default useMailQueueTracking;